import useAuth from "../core/hooks/useAuth";
import {useState} from "react";
import menuIcon from "../styles/assets/icons/menu.svg";
import mittelLogo from "../styles/assets/mittel.jpg";
import {ENUM} from "../core/utils/enum";
import {Link, Route, Switch, withRouter, Redirect} from "react-router-dom";
import {Button} from "react-bootstrap";
import userIcon from "../styles/assets/icons/user.svg";
import logoutIcon from "../styles/assets/icons/logout.svg";
import Menu from "./menus/Menu";
import {ConfirmModalProvider} from "./modal/ConfirmModalProvider";
import ArticlesPage from "./articles/ArticlesPage";
import UsersPage from "./users/UsersPage";
import BrandsPage from "./brands/BrandsPage";
import CategoriesPage from "./categories/CategoriesPage";
import CountriesPage from "./countries/CountriesPage";
import RetailersPage from "./retailers/RetailersPage";
import MarketPage from "./market/MarketPage";
import {fetchPromises} from "../core/utils/fetchPromises";

function MainPage({location, categories, user}) {
    const {logout} = useAuth();
    const [showMenu, setShowMenu] = useState(false);
    const paths = location.pathname.split('/');
    const currentPath = paths[1];
    const categoryId = categories && categories[0].id;

    return (
        <div className="wrapper">
            <div className="header">
                <div className="header-menu-icon d-md-none" onClick={() => setShowMenu(!showMenu)}>
                    <img src={menuIcon} alt="menu bar" />
                </div>
                <div className="header-title d-flex align-items-center">
                    <img className="header-logo" src={mittelLogo} alt="mittel" />
                    <span className="d-none d-md-block">- Market</span>
                </div>
                <div className="header-menu">
                    {currentPath !== ENUM.route.admin &&
                        <Link to={`/${ENUM.route.admin}/${ENUM.route.articles}`} className="me-2">
                            <Button variant="outline-primary">Admin</Button>
                        </Link>
                    }
                    {currentPath !== ENUM.route.market &&
                        <Link to={`/${ENUM.route.market}/${categoryId}`} className="me-2">
                            <Button variant="outline-primary">Market</Button>
                        </Link>
                    }
                    <div className="vr ms-3 me-2"></div>
                    <div className="header-menu-user d-none d-md-flex">
                        <img className="me-1" src={userIcon} alt="user" />
                        <span>{user && user.name}</span>
                    </div>
                    <Button className="d-flex align-items-center" size="sm" onClick={logout} variant="outline-primary">
                        <img src={logoutIcon} alt="logout"/>
                        <span className="d-none d-md-block ms-1">Logout</span>
                    </Button>
                </div>
            </div>
            <div className="content">
                <ul className={`menu ${showMenu ? 'open' : ''}`}>
                    <Menu user={user} setShowMenu={setShowMenu} />
                </ul>
                <Switch>
                    <ConfirmModalProvider>
                        <Route path={`/${ENUM.route.admin}/${ENUM.route.articles}`} component={ArticlesPage}/>
                        <Route path={`/${ENUM.route.admin}/${ENUM.route.users}`} component={UsersPage}/>
                        <Route path={`/${ENUM.route.admin}/${ENUM.route.brands}`} component={BrandsPage}/>
                        <Route path={`/${ENUM.route.admin}/${ENUM.route.categories}`} component={CategoriesPage}/>
                        <Route path={`/${ENUM.route.admin}/${ENUM.route.countries}`} component={CountriesPage}/>
                        <Route path={`/${ENUM.route.admin}/${ENUM.route.retailers}`} component={RetailersPage}/>
                        <Route path={`/${ENUM.route.market}/:categoryId`} component={MarketPage}/>
                        <Redirect from="/" to={`/${ENUM.route.market}/${categories[0].id}`} />
                    </ConfirmModalProvider>
                </Switch>
            </div>
        </div>
    );
}

export default withRouter(
    fetchPromises({
        categories: () => ({ name: 'getCategories' }),
    })(MainPage)
);
